export const CONTENT_TYPES = [
  "problem",
  "solution",
  "card",
  "comment",
] as const;

export type ContentType = (typeof CONTENT_TYPES)[number];

export const isValidContentType = (value: string): value is ContentType =>
  CONTENT_TYPES.includes(value as ContentType);
